module.exports = __webpack_public_path__ + "img/md_titi.6f87167e.png";